<template>
  <a
    :href="path"
    :class="$style.button"
    target="_blank"
    rel="noopener"
  >
    <NewButton :type="type">
      <component
        v-if="icon && !secondary"
        :class="$style.icon"
        :is="icon"
      />
      {{ $t('modals.startLesson.install') }}
    </NewButton>
  </a>
</template>

<script setup>
import NewButton from '@/shared/components/UI/Button/NewButton.vue';
import { BUTTON_TYPES } from '@/shared/components/UI/Button/button';
import { computed } from 'vue';
import { config } from '@/deepLinks/components/StoreButton/config';
import { getPlatform } from '@/shared/utils/getPlatform';

const platform = getPlatform();
const { icon, path } = config[platform];

const { secondary } = defineProps({
  secondary: {
    type: Boolean,
    default: false,
  },
});

const type = computed(() => secondary ? BUTTON_TYPES.OUTLINE_BLUE : BUTTON_TYPES.PRIMARY);

</script>

<style lang="scss" module>
.button {
  display: block;
  margin-top: 12px;

  & > button {
    height: 44px;
    padding: 0;
  }
}

.icon {
  color: $text-invert;
}
</style>
